<template>
  <div class="fair-survey-step fair-survey-step--wide">
    <div class="fair-survey-step__head">
      <h2 class="fair-survey-step__title">
        {{ step.title }}
      </h2>
      <p
        v-if="step.subtitle"
        class="fair-survey-step__subtitle"
      >
        {{ step.subtitle }}
      </p>
    </div>

    <div class="fair-survey-step__grid">
      <button
        v-for="style in step.styles"
        :key="style.id"
        type="button"
        class="fair-survey-step__card"
        :class="{ 'fair-survey-step__card--selected': isStyleLiked(style.id) }"
        :aria-pressed="isStyleLiked(style.id)"
        @click="toggleLike(style.id)"
      >
        <img
          class="fair-survey-step__card-media"
          :src="style.image"
          :alt="style.name"
        >
        <span class="fair-survey-step__card-label">{{ style.name }}</span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useGiftModal } from '@/features/gift/store'
import type { GiftStep } from '@/features/gift/types/gift-config'

interface Props {
  step: GiftStep & { type: 'style_likes' }
}

const props = defineProps<Props>()
const giftStore = useGiftModal()

const likedStyles = computed(() => {
  return giftStore.giftModal.giftData[props.step.id] || []
})

function isStyleLiked(styleId: string): boolean {
  return likedStyles.value.includes(styleId)
}

function toggleLike(styleId: string) {
  const currentLikes = [...likedStyles.value]
  const index = currentLikes.indexOf(styleId)

  if (index > -1) {
    currentLikes.splice(index, 1)
  } else {
    currentLikes.push(styleId)
  }

  giftStore.updateGiftData(props.step.id, currentLikes)
}

onMounted(() => {
  // Initialize with existing data if any
  if (!giftStore.giftModal.giftData[props.step.id]) {
    giftStore.updateGiftData(props.step.id, [])
  }
})
</script>
